export default {
  brandColor1: '#fad2dc',
  complimentaryColor1: '#272a8d',
  brandColor2: '#272a8d',
  complimentaryColor2: '#fff',
};
